import type { ChatMessage } from '@/types/chatContext';

export const CHAT_INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;
export const CHAT_MAX_MESSAGE_COUNT = 40;

export function isChatSessionStale(messages: ChatMessage[]): boolean {
  if (messages.length === 0) return false;
  if (messages.length >= CHAT_MAX_MESSAGE_COUNT) return true;
  const last = messages[messages.length - 1];
  const ts = Date.parse(last.timestamp);
  if (isNaN(ts)) return true;
  return Date.now() - ts >= CHAT_INACTIVITY_TIMEOUT_MS;
}
